import chroma from "chroma-js";

import COLORS from "../constants/colors";

export function getBlackOrWhiteColorByContrast(color: string): string {
  return chroma.contrast(color, "white") > 2 ? "white" : COLORS.grey[800];
}
